import React, {useContext} from 'react';
import {FormFieldItemPropsContext} from '../../../../src/contexts/FormFieldItemPropsContext';
import {IFormFieldItemPropsContext} from '../../../../src/@interfaces/contexts/IFormFieldItemPropsContext';
import {IOrderModel} from '../../../../src/@interfaces/models/Order/IOrderModel';
import {IListColumnProps} from '../../../../src/@interfaces/components/List/IListColumnProps';
import HasNewCommentIndicator from '../../HasNewCommentIndicator';

export function IndicatorsField({rowIndex: index}: IListColumnProps) {
    const {model} = useContext<IFormFieldItemPropsContext<IOrderModel> | null>(FormFieldItemPropsContext) ?? {};
    const hasNewComments = model?.products?.[index]?.has_new_comments;

    return <HasNewCommentIndicator active={hasNewComments ?? false}/>;
}
